import { useQuery } from "@tanstack/react-query";

import type { DashboardRange } from "@flexv-coach/shared";
import { dashboardApi } from "@/lib/api";

/**
 * Ringkasan dashboard coach. Agregasi dikerjakan server, jadi kunci query
 * cukup berisi rentang — ganti rentang = refetch otomatis.
 */
export function useCoachDashboard(range: DashboardRange) {
    return useQuery({
        queryKey: ["coach-dashboard", range],
        queryFn: ({ signal }) => dashboardApi.get({ range }, signal),
    });
}
